module.exports = __webpack_public_path__ + "static/media/suv-avatar.3a231694.svg";